export class Logger {
  static debug(message: string) {
    if (!import.meta.env.DEV) {
      return;
    }
    // eslint-disable-next-line no-console
    console.log(`[DEBUG] ${message}`);
  }

  static warn(message: string) {
    if (!import.meta.env.DEV) {
      return;
    }
    // eslint-disable-next-line no-console
    console.warn(`[WARN] ${message}`);
  }

  static error(message: string, error?: Error) {
    if (!import.meta.env.DEV) {
      return;
    }
    // eslint-disable-next-line no-console
    console.error(`[ERROR] ${message}`, error);
  }
}
